module.exports = __webpack_public_path__ + "static/media/img_3_1685965575298.24a5dfaa.jpg";